/**
 * @author Ariel
 * @date 2020-08-21
 * @desc 栏目应用列表页配置
 * @update 2020-08-27 栏目应用分类弹出框
 */
import React from 'react'
import {component_tool, framework_tool} from '../../../tool';
import {WizTableForm} from "../../common";

let {ossFileUtils} = framework_tool
let {WizModal} = component_tool;
const categoryConfig = WizTableForm.Config.categoryInfo(this, {apiParams: {type: 4, state: 1}})
const applicationConfig = WizTableForm.Config.applicationInfo(this, {apiParams: {status: 1}})

let componentName = 'applicationColumn'

const columns = (pushProps = {}) => {
  let applicationIdProps = {...applicationConfig}
  if (pushProps) {
    applicationIdProps = {
      ...applicationConfig,
      initialValue: pushProps.id,
      initRows: [{id: pushProps.id, name: pushProps.name}],
    }
  }
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '应用名称',
      name: 'name',
      searchItem: {},
    },
    {
      title: '类型',
      name: 'type',
      searchItem: {
        type: 'select'
      },
      dict: [
        {code: 0, codeName: '独立应用'},
        {code: 1, codeName: '内嵌应用'},
        {code: 2, codeName: '外链'}
      ]
    },
    {
      title: '分类',
      name: 'categoryId',
      searchItem: {
        ...categoryConfig,
        diy: WizTableForm,
        selectType: 'radio',
      },
    },
    {
      title: '所属服务',
      name: 'applicationId',
      searchItem: {
        diy: WizTableForm,
        ...applicationIdProps,
        selectType: 'radio',
      },
    },
    {
      title: '封面',
      name: 'img',
      tableItem: {
        render: (text, record) => {
          let url = getOssFilePath(record.img)
          // ossFileUtils.getOssFile(
          //   record.img,
          //   record.fileName,
          //   record.fileMimeType,
          //   record.fileSize,
          //   record.fileUri,
          // ).url
          url = record.img ? url : constants.files.sys_img_loadingFailed;
          return <div style={{display: 'flex', 'justify-content': 'flex-start', marginRight: 0,}}>
            <div>
              <img height={50} width={50} src={url}/>
            </div>
          </div>
        }
      }
    },
    {
      title: '应用名称',
      name: 'name',
      tableItem: {},
    },
    {
      title: '类型',
      name: 'type',
      tableItem: {},
      dict: [
        {code: 0, codeName: '独立应用'},
        {code: 1, codeName: '内嵌应用'},
        {code: 2, codeName: '外链'}
      ]
    },
    {
      title: '适用终端',
      name: 'adapterNames',
      tableItem: {}
    },
    {
      title: '分类',
      name: 'categoryName',
      tableItem: {},
    },
    {
      title: '所属服务',
      name: 'applicationName',
      tableItem: {},
    },
    {
      title: '状态',
      name: 'status',
      tableItem: {},
      searchItem: {
        type: 'select'
      },
      dict: [
        {code: 0, codeName: '禁用'},
        {code: 1, codeName: '启用'},
        { code: 2, codeName: '待开发' },
      ]
    },
    {
      title: '适用终端',
      name: 'adaptersList',
      searchItem: {
        type: 'select'
      },
      dict: [
        {code: 0, codeName: 'PC'},
        {code: 1, codeName: 'APP'},
        // {code: 2, codeName: '企业号'},
        // {code: 3, codeName: '小程序'},
        {code: 4, codeName: '凯迪拉克IQ'},
        {code: 5, codeName: '雪佛兰企微'},
        {code: 6, codeName: '别克企微'},
        {code: 7, codeName: '凯迪拉克企微'},
      ]
    },
  ];
}

const templateConfig = (data) => {
  let {pushProps} = data
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns : columns(pushProps),
        searchBarProps: {
          buttonSort: ['add', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: {icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/application/applicationColumn/applicationColumnDetailAdd'
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['look', 'update', 'recordManagement', 'enableOrDisable'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: {children: "查看"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/application/applicationColumn/applicationColumnLook"
              }
            }
          },
          {
            key: "update",
            custom: true,
            params: {children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/application/applicationColumn/applicationColumnDetailUpd"
              }
            }
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: {children: "启用"},
            textFormat: {
              recordKey: 'status',
              dirt: {'1': '禁用', '0': '启用', '2': '启用',}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['status'] === 0 || record['status'] === 2 ? "启用" : "禁用"
                }该栏目应用吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      status: record['status'] === 0 || record['status'] === 2 ? 1 : 0,
                      id: record['id'],
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "recordManagement",
            custom: true,
            params: {children: "记录管理"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/application/applicationColumn/applicationColumnRecord"
              }
            }
          },
        ]
      }
    }
  }
};

const apis = (applicationId = []) => {
  return {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {applicationId: applicationId}
      }
    },
    enable: {
      path: `${componentName}/enable`,
      payload: {
        key: `${componentName}@enable`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {applicationId:applicationId}
      }
    }
  }
}

let reduxTemplateConfig = (args) => {
  let {applicationId} =args
  return {
    apis: apis(applicationId),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
